import tableUtils from "../logic/tableUtils.js"
import config from "../config"
import flt from "../logic/filterGenerator.js"

export default [

  (inputTable, outputTable) => {
    if(!tableUtils.hasColumn(outputTable, "Conversions")) return false
    if(!tableUtils.hasColumn(outputTable, "Cost")) return false

    const allCosts = tableUtils.sum(inputTable, "Cost")
    const allConversions = tableUtils.sum(inputTable, "Conversions")
    const averageConversionCost = allCosts / allConversions

    if(tableUtils.anyRow(outputTable, ["Conversions", "Cost"],
        (conversions, cost) => {
          //console.log("Cost", cost, averageConversionCost)
          return conversions == 0 && cost/100 > averageConversionCost * 3
        }
      )) {
      let filter = {
        name: "tip1_highCost",
        text: "You have words with very high cost, and no conversions",
        filter: flt.create(
          flt.include(
            flt.gt("Cost", (averageConversionCost * 3).toFixed(2)),
            flt.eq("Conversions", 0)
          )
        )
      }
      return filter
    }

    return false
  },

  (inputTable, outputTable) => {
    if(!tableUtils.hasColumn(outputTable, "CC")) return false
    if(!tableUtils.hasColumn(outputTable, "Conversions")) return false
    if(!tableUtils.hasColumn(outputTable, "Cost")) return false

    if(!tableUtils.hasColumn(inputTable, "Conversions")) return false
    if(!tableUtils.hasColumn(inputTable, "Cost")) return false

    const allCosts = tableUtils.sum(inputTable, "Cost")
    const allConversions = tableUtils.sum(inputTable, "Conversions")
    const averageConversionCost = allCosts / allConversions
    //console.log("AVG Conv cost", averageConversionCost)

    if(tableUtils.anyRow(outputTable, ["Conversions", "Cost"],
        (conversions, cost) => {
          if(conversions <= 0) return false
          const convCost = cost / conversions
          return ( cost > averageConversionCost * 3 ) && ( convCost > averageConversionCost * 3 )
        }
      )) {
      let filter = {
        name: "tip2_highCost",
        text: "You have words with outstanding cost and conversion cost",
        filter: flt.create(
          flt.include(
            flt.gt("Cost", (averageConversionCost * 3).toFixed(2)),
            flt.gt("CC", (averageConversionCost * 3).toFixed(2)),
            flt.gt("Conversions", 0)
          )
        )
      }
      return filter
    }

    return false
  }

]






// WEBPACK FOOTER //
// ./src/config/wordsTips.js